import initReducer from '../lib/init-reducer'
import initialState from './initial-states/config'
export default initReducer(initialState, {
  SET_MOBILE: (state, action) => ({ ...state, mobile: action.value }),
  SET_WINDOW_HEIGHT: (state, action) => ({ ...state, windowHeight: action.value })
})


// WEBPACK FOOTER //
// ./src/reducers/ConfigReducer.js